import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { ToastRoot } from "../Components/Toast/ToastRoot";
import { VoiceCallBar } from "../Components/VoiceCallBar/VoiceCallBar";
import { TimeHelper } from "../Helpers/Time/Time.Helper";
import { useDailyReboot } from "../Hooks/useDailyReboot";
import AccountModel from "../Models/Account/AccountModel";
import { CCPresenceHost } from "./Layout/CCPresenceHost";
import "./Layout/Layout.scss";
import { LoadingView } from "./Layout/Loading/LoadingView";
import { SSModal } from "./Layout/Modal/SSModal";
import Router from "./Routers/Router";
import RouterLoggedOut from "./Routers/RouterLoggedOut";

function App() {
  const { account, member, accountLoaded, accountIsLoading } = AccountModel.useState((s) => s);

  useDailyReboot();

  useEffect(() => {
    AccountModel.loadAccount();

    const cleanupTimeSync = TimeHelper.startSyncingTime();

    if (localStorage.getItem("debugSet") !== "true") {
      localStorage.setItem("debugSet", "true");
      localStorage.setItem("debug", "error:*, warn:*, info:*, debug:*, notifications:*,users:*");

      // Uncomment the line below to enable debug mode in development
      // localStorage.set("debugSet", "true");
    }

    return () => {
      cleanupTimeSync();
    };
  }, []);

  if (!accountLoaded || accountIsLoading) {
    return (
      <div className="App">
        <LoadingView />
      </div>
    );
  }

  return (
    <>
      <BrowserRouter>
        {!member ? <RouterLoggedOut account={account} /> : <Router />}
        <ToastRoot account={account} />
        {/* Keeps an available agent routable and lets them accept an escalation
            from any page (ENG-3098). Members only — no presence for a logged-out
            visitor. */}
        {member && <CCPresenceHost />}
        <VoiceCallBar />
      </BrowserRouter>
      <ToastContainer style={{ zIndex: 800 }} />
      <SSModal />
    </>
  );
}

export default App;
